/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2025 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { appointmentindex } from '../schedule/appointmentindex';

export class appointmentstat extends appointmentindex {

  public gettablename(): string {
    return "APPOINTMENT_STAT";
  }
}
